export default "data:image/webp;base64,UklGRkQAAABXRUJQVlA4TDcAAAAvJ4AGADUoiiTFwRmFXPyNCsKF5woJCP93GUUTC6a4ZzD1P9O/g7AiEuRUJKO1cioSYUUk/TsAAA=="